/* eslint-disable react/jsx-no-undef */
import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, DatePicker, Form, Input, Modal, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import { getSelectBoxWorkStatusActivities } from 'app/entities/common/common.reducer';
import { StatusType } from 'app/shared/model/enum/status.enum';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import { Container } from 'reactstrap';
import { checkInEntity, getEntityCheckIn, reset } from '../../../activities.reducer';
import ReportActivitiesResult from '../view/reportActivitiesResult';

type IReportActivities = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
  idSelected: string;
};

export const ReportActivities = ({ isOpen, onClose, idSelected }: IReportActivities) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  const updating = useAppSelector(state => state.activities.updating);
  const updateSuccess = useAppSelector(state => state.activities.updateSuccess);
  const workStatusActivitiesList = useAppSelector(state => state.common.workStatusActivities);
  const activitiesEntity = useAppSelector(state => state.activities.entity);
  const filters = useAppSelector(state => state.filters.activities);
  const [isChangeWorkStatus, setIsChangeWorkStatus] = useState(null);

  // init state
  const [visibleModalReportResult, setVisibleModalReportResult] = useState(false);

  // watch values form
  const workStatusValues = Form.useWatch('workStatus', form);


  const handleClose = () => {
    form.resetFields();
    onClose(updateSuccess);
  };

  useEffect(() => {
    dispatch(getSelectBoxWorkStatusActivities())
    if (idSelected) {
      dispatch(getEntityCheckIn(idSelected));
    }
  }, [idSelected]);

  useEffect(() => {
    if (activitiesEntity) {
      form.setFieldsValue({
        ...activitiesEntity,
        dueDate: activitiesEntity?.dueDate && dayjs(activitiesEntity.dueDate).format(APP_LOCAL_DATE_FORMAT),
        completedOn: activitiesEntity?.completedOn && dayjs(activitiesEntity.completedOn),
        expectedCompleteOn: activitiesEntity?.expectedCompleteOn && dayjs(activitiesEntity.expectedCompleteOn)
      })
    }
  }, [activitiesEntity]);

  useEffect(() => {
    if (updateSuccess) {
      dispatch(reset())
      handleClose();
    }
  }, [updateSuccess]);

  // eslint-disable-next-line complexity
  const handleSubmit = values => {
    const entity = {
      ...values,
      activityId: idSelected,
      completedOn: dayjs(values.completedOn).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
      expectedCompleteOn: dayjs(values.expectedCompleteOn).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
    };
    dispatch(checkInEntity(entity));
  };

  const handleCloseModalReportActivitiesResult = () => {
    setVisibleModalReportResult(false);
  };

  const handleViewReportResult = (event) => {
    event.preventDefault();
    setVisibleModalReportResult(true);
  };

  const handleChangeWorkStatus = (value) => {
    setIsChangeWorkStatus(value)
  }

  return (
    <Modal
      width={1300}
      open={isOpen}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      <Container className="form">
        <Form size="large" form={form} onFinish={handleSubmit} layout="vertical">
          <Title level={3}>{`Check in công việc ${filters?.accountableName ? `- ${filters?.accountableName}` : ''}`}</Title>
          <Row>
            <Col md={11}><h5 className='fw-bold'>Thông tin công việc</h5></Col>
            <Col md={1} />
            <Col md={12}><span onClick={(e) => { handleViewReportResult(e) }} className='text-primary cursor-pointer fw-bold'>Xem kết quả thực hiện công việc</span></Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Item label="Mã công việc" name={'code'}>
                <Input className="w-100" disabled size="large" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={8}>
              <Form.Item label="Nội dung công việc" name={'purpose'}>
                <TextArea rows={1} className="w-100" disabled size="large" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={4}>
              <Form.Item label="Thời hạn hoàn thành" name={'dueDate'}>
                <Input className="w-100" disabled size="large" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={5}>
              <Form.Item label="Mức độ ưu tiên" name={'workPriorityLevel'}>
                <Input className="w-100" disabled size="large" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Form.Item label="Lĩnh vực" name={'fieldName'}>
                <Input className="w-100" disabled size="large" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={4}>
              <Form.Item label="Dự án" name={'projectName'}>
                <Input className="w-100" disabled size="large" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={4}>
              <Form.Item label="Mảng công việc" name={'workTypeName'}>
                <Input className="w-100" disabled size="large" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={4}>
              <Form.Item label="Người giao việc" name={'assignedByName'}>
                <Input className="w-100" disabled size="large" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={4}>
              <Form.Item label="PIC" name={'picName'}>
                <Input className="w-100" disabled size="large" />
              </Form.Item>
            </Col>
          </Row>
          <hr />
          <h5 className='fw-bold'>Kết quả thực hiện</h5>
          <Row>
            <Col md={7}>
              <Form.Item label="Kỳ báo cáo" name="reportScheduleName">
                <Input className="w-100" disabled size="large" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={7}>
              <Form.Item label="Tình trạng" rules={[{ required: true, message: 'Hãy chọn tình trạng' }]} name="workStatus">
                <Select
                  filterOption={filterOption}
                  allowClear
                  showSearch
                  size="large"
                  onChange={handleChangeWorkStatus}
                  options={workStatusActivitiesList}
                  placeholder="Chọn tình trạng"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            {(workStatusValues !== null && workStatusValues !== StatusType.Cancel) && (
              (workStatusValues === StatusType.OnTrack || workStatusValues === StatusType.NotStarted) ?
                (
                  <Col md={8}>
                    <Form.Item
                      label={`Ngày hoàn thành dự kiến`}
                      rules={[
                        {
                          required: true,
                          message: `Hãy chọn ngày hoàn thành dự kiến`,
                        },
                      ]}
                      name="expectedCompleteOn"
                    >
                      <DatePicker
                        format={APP_LOCAL_DATE_FORMAT}
                        placeholder={`Chọn ngày hoàn thành dự kiến`}
                        className="w-100"
                      />
                    </Form.Item>
                  </Col>
                )
                :
                (workStatusValues === StatusType.Completed &&
                  (<Col md={8}>
                    <Form.Item
                      label={`Ngày hoàn thành`}
                      rules={[
                        {
                          required: true,
                          message: `Hãy chọn ngày hoàn thành`,
                        },
                      ]}
                      name="completedOn"
                    >
                      <DatePicker
                        format={APP_LOCAL_DATE_FORMAT}
                        placeholder={`Chọn ngày hoàn thành`}
                        className="w-100"
                      />
                    </Form.Item>
                  </Col>)
                )
            )}
          </Row>
          <Row>
            <Col md={11}>
              <Form.Item label="Đã hoàn thành" name={'completeNote'} rules={[{ required: workStatusValues === StatusType.Completed, message: 'Vui lòng nhập' }]}>
                <TextArea rows={6} className="w-100" placeholder="Nhập nội dung đã hoàn thành" size="large" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={12}>
              <Form.Item label="Lý do không hoàn thành, Tạm dừng, Hủy" name={'unFinishNote'}
                rules={[{ required: workStatusValues !== null && workStatusValues !== StatusType.Completed, message: 'Vui lòng nhập' }]}>
                <TextArea rows={6} className="w-100" placeholder="Nhập nội dung chưa hoàn thành" size="large" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={24}>
              <Form.Item label="Kế hoạch kỳ tiếp theo" name={'nextPlanPeriodPurpose'} rules={[{ required: isChangeWorkStatus === StatusType.OnTrack || workStatusValues === StatusType.OnTrack, message: 'Vui lòng nhập kế hoạch kỳ tiếp theo' }]}>
                <TextArea rows={3} className="w-100" placeholder="Nhập nội dung kế hoạch" size="large" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={11}>
              <Form.Item label="Khó khăn & nguyên nhân" name={'issue'}>
                <TextArea rows={6} placeholder="Nhập khó khăn & nguyên nhân" size="large" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={12}>
              <Form.Item label="Giải pháp và kiến nghị" name={'solution'}>
                <TextArea rows={6} placeholder="Nhập giải pháp và kiến nghị" size="large" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={24}>
              <Form.Item label="Tài liệu đính kèm về kết quả thực hiện (link)" name={'note'}>
                <TextArea placeholder="Nhập tài liệu đính kèm về kết quả thực hiện" size="large" />
              </Form.Item>
              <Checkbox>Gửi thông báo đến người nhận</Checkbox>
            </Col>
          </Row>
          <Form.Item>
            <Row className="action mt-3" justify="end">
              <Col>
                <Button
                  className="secondary"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Hủy
                </Button>
              </Col>
              <Col>
                <Button className="primary" htmlType="submit" disabled={updating}>
                  Lưu
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
        {visibleModalReportResult && (
          <ReportActivitiesResult
            isOpen={visibleModalReportResult}
            idSelected={idSelected}
            onClose={handleCloseModalReportActivitiesResult}
          />
        )}
      </Container>
    </Modal>
  );
};

export default ReportActivities;
